<h1 mat-dialog-title>
    <span>{{ data.title }}</span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <list-view [liste]="liste"></list-view>
</div>